// Presentation helpers for the AI usage report (labels are i18n keys).
const FEATURE_ICONS = {
  agent_response: 'i-hugeicons-bot',
  bank_result_customer_render: 'i-hugeicons-bank',
  follow_up: 'i-hugeicons-bubble-chat-question',
  image_analysis: 'i-hugeicons-image-02',
  improve: 'i-hugeicons-magic-wand-01',
  ixc_direct_response_action_audit: 'i-hugeicons-security-check',
  label_suggestion: 'i-hugeicons-tag-01',
  reply_suggestion: 'i-hugeicons-mail-reply-01',
  summarize: 'i-hugeicons-file-02',
  unknown: 'i-hugeicons-sparkles',
};

const SOURCE_KEYS = {
  openai_node_responses_stream: 'AUTOMATIC_SERVICE',
  openai_node_responses_bank_render: 'BANK_RESULT',
  openai_node_responses_image: 'IMAGE_ANALYSIS',
  openai_node_responses: 'AI_AUTOMATION',
  'llm.follow_up': 'FOLLOW_UP',
  'llm.improve': 'IMPROVE',
  'llm.label_suggestion': 'LABEL_SUGGESTION',
  'llm.reply_suggestion': 'REPLY_SUGGESTION',
  'llm.summarize': 'SUMMARIZE',
};

export const BALANCE_STATUS_KEYS = {
  permission_required: 'PERMISSION_REQUIRED',
  not_configured: 'NOT_CONFIGURED',
  unavailable: 'UNAVAILABLE',
  no_limit: 'NO_LIMIT',
};

export const humanizeIdentifier = value =>
  String(value || 'unknown')
    .replace(/[._-]+/g, ' ')
    .replace(/\b\w/g, character => character.toUpperCase());

export const featurePresentation = (featureName, t) => {
  const name = featureName || 'unknown';
  if (!FEATURE_ICONS[name]) {
    return {
      label: humanizeIdentifier(name),
      description: t('AI_USAGE_REPORT.FEATURES.FALLBACK_DESCRIPTION'),
      icon: FEATURE_ICONS.unknown,
    };
  }

  const key = `AI_USAGE_REPORT.FEATURES.${name.toUpperCase()}`;
  return {
    label: t(`${key}.LABEL`),
    description: t(`${key}.DESCRIPTION`),
    icon: FEATURE_ICONS[name],
  };
};

export const sourceLabel = (sourceType, t) =>
  SOURCE_KEYS[sourceType]
    ? t(`AI_USAGE_REPORT.SOURCES.${SOURCE_KEYS[sourceType]}`)
    : humanizeIdentifier(sourceType);

export const formatModel = model => {
  if (!model) return '-';

  return String(model)
    .replace(/-\d{4}-\d{2}-\d{2}$/, '')
    .replace(/^gpt-/i, 'GPT-')
    .replace(/-(mini|nano|pro)$/i, ' $1');
};

export const formatTokens = value => Number(value || 0).toLocaleString('pt-BR');

export const formatCurrency = (value, currency) =>
  Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency });

export const percentOf = (value, total) => {
  const base = Number(total || 0);
  if (!base) return 0;
  return Math.min(100, Math.round((Number(value || 0) / base) * 100));
};
